<template>
    <div id="LeftNav">
        <mu-paper class="left_nav" :style="{width: !$store.state.menuExpand? '240px': '64px'}">
            <mu-flex class="brand" direction="column" :style="{padding: !$store.state.menuExpand? '32px 24px': '32px 16px'}">
                <img v-if="$store.state.lang =='zh' || $store.state.lang =='zh-CN'" :src="!$store.state.menuExpand? logoPic : smallLogo" :style="{width: !$store.state.menuExpand? '100%': '32px'}"/>
                <img v-else :src="!$store.state.menuExpand ? logoEn : smallLogo" :style="{width: !$store.state.menuExpand? '125px': '32px'}"/>
                <p class="title" v-if="!$store.state.menuExpand">{{$t('common.systemName')}}</p>
            </mu-flex>
            <el-menu :default-active="$route.path" class="nav_bar" router :collapse="$store.state.menuExpand" unique-opened>
                <template v-for="menuWrap in menuList">
                    <el-menu-item :index="menuWrap.menu.uri" v-if="menuWrap.menuList.length == 0" :key="menuWrap.menu.id">
                        <mu-icon :value="menuWrap.menu.icon" :size="18"></mu-icon>
                        <span slot="title">{{$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? menuWrap.menu.name : menuWrap.menu.rename}}</span>
                    </el-menu-item>
                    <el-submenu v-else :key="menuWrap.menu.id" :index="menuWrap.menu.uri">
                        <template slot="title">
                        <mu-icon :value="menuWrap.menu.icon" :size="18"></mu-icon>
                        <span slot="title">{{$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? menuWrap.menu.name : menuWrap.menu.rename}}</span>
                        </template>
                        <template v-for="menu in menuWrap.menuList">
                          <el-menu-item :index="menu.uri" :key="menu.id" v-if="isActiveUser(menu)">
                            {{$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? menu.name : menu.rename}}
                          </el-menu-item>
                        </template>
<!--                        <el-menu-item :index="menu.uri" v-for="menu in menuWrap.menuList" :key="menu.id">-->
<!--                            {{$store.state.lang == 'zh' || $store.state.lang == 'zh-CN' ? menu.name : menu.rename}}-->
<!--                        </el-menu-item>-->
                    </el-submenu>
                </template>
            </el-menu>
        </mu-paper>
    </div>
</template>
<script>
// import logoPic from '@/assets/image/zenithLogo/logo.png';
// import smallLogo from '@/assets/image/zenithLogo/logo_mini.png';
import logoPic from '@/assets/image/logo.png';
import smallLogo from '@/assets/image/logo_mini.png';
import logoEn from '@/assets/image/logo_en.png';
import store from '@/vuex/store'
export default {
    name: "LeftNav",
    data() {
        return {
            logoPic: logoPic,
            smallLogo: smallLogo,
            logoEn:logoEn,
            menuList:[],
            menuLang: '',
        }

    },
 created() {
    this.menuList = store.state.menuArray;
    console.log(this.menuList)
    this.menuLang = store.state.lang;

  },
  watch: {
      menuLang(newVal) {
          this.$forceUpdate();
      }
  },
  mounted() {
  },
  methods: {
    isActiveUser(menu) {
      var custId = store.state.user.custId;
      var roleId = store.state.user.roleId;
      // if(roleId == 1){
      //   return true;
      // }
      // if (menu.id == 17 || menu.id == 49) {
      //
      //   if(custId == "77d252e899584d61a3393abce281" //山东智教信息科技有限公司
      //     ||custId == "b3e0b6537997412db779f92793006a69" //青岛地铁集团有限公司运营分公司
      //     || custId == "82d5881428fa4e368e02ce59e3b29999" //吉利集团
      //     || custId == "445113d8f0c54fc885f242c0e79653ca" //陕西恒朗鼎志信息科技有限公司
      //     || custId == "fc593b5ca37e42cb9619673b9b0b3616" //中通服科信信息技术有限公司
      //     || custId == "f47563043db742e3b91337632982c7b5" //陕西国驿软件科技有限公司
      //     || custId == "753fe282ba9342a5ade3ad3ff1880daa" //深圳市怡达通进出口有限公司
      //     || custId == "b0cdbedae4d0413f8eadc6b4ff155195" //903485472@qq.com
      //     || custId == "040b6d17bd6f4d30b30ca7ce13d12a5f" //深圳市思卡乐科技有限公司
      //     || custId == "26c6c29d34734adda1a7c9c43cb03443" //安建建材
      //     || custId == "5ce3c2131e6b44f6b0c0247fb9c71f95" //浙江大境筑科技发展有限公司
      //     || custId == "eb1e8608413049c185b4e46357a3d6ba" //浙江海拓环境技术有限公司
      //     || custId == "32bc1800665d4ea495cd847b6e32faac" //中商惠民
      //     || custId == "d3cc48a4b98d4100a4285df1db492ff2" //wangshunwei@cilico.com自测
      //     || custId == "dee4832866bc4a8d9e3ed16971f433f6" //zhanglei@cilico.com自测
      //     || custId == "4cf555b44cf7422c81df7335f6dabf25" //15035937515@163.com自测
      //     || custId == "4406823f1a184a889dc3434c4f1ecdb5" //gaojing@cilico.com自
      //     || custId == "df88a6df13ae4d20a0ad62a81c1ceea5" //杨荣鑫自测
      //   ){
      //     return true;
      //   } else {
      //     return false
      //   }
      // }
      return true;
    }
  }
}
</script>
<style scoped>
.left_nav {
    position: fixed;
    top:0px;
    left:0px;
    z-index: 2;
    height:100vh;
    overflow: auto;
    background:linear-gradient(1deg,rgba(43,100,241,1) 0%,rgba(91,132,255,1) 100%);
}
.brand {
    width:100%;
    padding:32px 24px;
}
.brand img {
    width:100%;
    height:auto;
}
.brand .sub_title {
    font-size:16px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:24px;
    font-family: 'DINCOND';
}
.brand .title {
    font-size:16px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:24px;
    font-family: 'DINCOND';
}
</style>



// WEBPACK FOOTER //
// src/components/LeftNav.vue